<ng-container *ngIf="status$ | async as status; else loading;">
  <img class="ion-icon" *ngIf="!status.hearted" color="secondary" size="large" src="assets/icons/heart-empty.svg" (click)="createHeart()"/>
  <img class="ion-icon" *ngIf="status.hearted && status.hearted==''" color="secondary" size="large" src="assets/icons/heart-empty.svg" (click)="createHeart()"/>
  <img class="ion-icon" *ngIf="status.hearted && status.hearted!=''" color="secondary" size="large" src="assets/icons/heart.svg" (click)="removeHeart()"/>
</ng-container><ng-template #loading>
  <img class="ion-icon" color="secondary" size="large" src="assets/icons/heart-empty.svg" (click)="createHeart()"/>
</ng-template>
